/// <amd-module name="Build/Admin/Checks/Stores/ChecksStore" />
import { Store } from "VSS/Reflux/Store";

import { StoreStatus } from "Build/Admin/Common/Constants";

export interface IChecksStoreState {
    status: StoreStatus;
}

// This is essentially a shim to help us determine whether or not the checks
// component has loaded its data because we currently need to load it async
// from the page.
export class ChecksStore extends Store {
    public state: IChecksStoreState = {
        status: StoreStatus.None
    };

    constructor() {
        super("ChecksStoreChanged");
    }

    public updateStatus = (status: StoreStatus): void => {
        this.state = {
            status
        };

        this.emitChanged();
    }
}
